import SendTwoFactorAuthenticationCodeProxy from "./send-otp"

const state = {};

const getters = {};

const actions = {
  async sendTwoFactorAuthCode({ rootState }, payload) {
    const user = rootState.userModule.user || payload;
    const proxy = new SendTwoFactorAuthenticationCodeProxy();
    const isLogin = payload ? payload.isLogin : false;
    const channel = payload ? payload.channel : null;
    return await proxy.sendTwoFactorAuthCode({
      userId: user._id,
      phone: user.phone,
      isLogin,
      channel,
    });
  },
  // eslint-disable-next-line no-empty-pattern
  async validateTwoFactorAuthCode({}, payload) {
    const proxy = new SendTwoFactorAuthenticationCodeProxy();
    const response = await proxy.validateTwoFactorAuthCode({
      userId: payload.userId,
      code: payload.code,
      isSentFromV2: payload.isSentFromV2,
      isCreateUser: payload.isCreateUser,
      isInvitation: payload.isInvitation,
      actions: payload.actions,
      companyName: payload.companyName,
    });
    return response;
  },
  // eslint-disable-next-line
  async validateOnboardingTwoFactorAuthCode({ }, payload) {
    const proxy = new SendTwoFactorAuthenticationCodeProxy();
    const response = await proxy.validateOnboardingTwoFactorAuthCode({
      userId: payload.userId,
      code: payload.code,
      isSentFromV2: payload.isSentFromV2,
      actions: payload.actions,
      companyName: payload.companyName,
    });
    return response;
  },
};

const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
